import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';

const EquityOnCancelledContractRow = ({ rowData, id, nestedColumnsNumber }) => {
  const { purchaserName, onePortalId, particulars } = rowData;

  return (
    <tr key={id} className="table-body-tr eq-tr">
      <td width="50px" align="center" className="valign-middle">
        {onePortalId}
      </td>
      <td className="valign-middle td-ex-break ">
        <div className="mb-1 display-block">{purchaserName}</div>
      </td>
      {[...Array(nestedColumnsNumber)].map((_col, column) => {
        return (
          <td key={column} className="p-0 tb-next eq-td">
            {particulars?.map((rowDataValues, rdIndex) => {
              const clasName =
                particulars?.length >= 2 ? 'inner-table-1' : 'inner-table-1 eq-table';
              return (
                <table key={rdIndex} className={clasName}>
                  <tbody>
                    {column === 0 && (
                      <tr className="tr-next-1">
                        <td id={rowDataValues?.contractNumber}>
                          {rowDataValues?.contractNumber}
                          <span className="unit-no td-ex-break">
                            {rowDataValues?.addendumNumber && `(${rowDataValues?.addendumNumber})`}
                          </span>
                        </td>
                      </tr>
                    )}
                    {column === 1 && (
                      <tr
                        className="tr-next"
                        style={{
                          background: rowDataValues?.currentPeriod === '0-12m' ? '#B9F1EE' : '',
                        }}
                      >
                        <td
                          width={`${100 / 2}%`}
                          height={
                            document.getElementById(rowDataValues?.contractNumber)?.offsetHeight
                          }
                        >
                          {getPrice(rowDataValues?.month12Equity)}
                        </td>
                        <td>{getPrice(rowDataValues?.month12OtherIncome)}</td>
                      </tr>
                    )}
                    {column === 2 && (
                      <tr
                        className="tr-next"
                        style={{
                          background: rowDataValues?.currentPeriod === '13-24m' ? '#B9F1EE' : '',
                        }}
                      >
                        <td
                          width={`${100 / 2}%`}
                          height={
                            document.getElementById(rowDataValues?.contractNumber)?.offsetHeight
                          }
                        >
                          {getPrice(rowDataValues?.month24Equity)}
                        </td>
                        <td>{getPrice(rowDataValues?.month24OtherIncome)}</td>
                      </tr>
                    )}
                    {column === 3 && (
                      <tr
                        className="tr-next"
                        style={{
                          background: rowDataValues?.currentPeriod === '25-36m' ? '#B9F1EE' : '',
                        }}
                      >
                        <td
                          width={`${100 / 2}%`}
                          height={
                            document.getElementById(rowDataValues?.contractNumber)?.offsetHeight
                          }
                        >
                          {getPrice(rowDataValues?.month36Equity)}
                        </td>
                        <td>{getPrice(rowDataValues?.month36OtherIncome)}</td>
                      </tr>
                    )}
                    {column === 4 && (
                      <tr
                        className="tr-next"
                        style={{
                          background: rowDataValues?.currentPeriod === 'above-36' ? '#B9F1EE' : '',
                        }}
                      >
                        <td
                          width={`${100 / 2}%`}
                          height={
                            document.getElementById(rowDataValues?.contractNumber)?.offsetHeight
                          }
                        >
                          {getPrice(rowDataValues?.above36Equity)}
                        </td>
                        <td>{getPrice(rowDataValues?.above36OtherIncome)}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              );
            })}
          </td>
        );
      })}
    </tr>
  );
};

EquityOnCancelledContractRow.propTypes = {
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string.isRequired,
    onePortalId: PropTypes.string.isRequired,
    particulars: PropTypes.shape([
      {
        contractNumber: PropTypes.string,
        addendumNumber: PropTypes.string,
        currentPeriod: PropTypes.string,
        month12Equity: PropTypes.number,
        month12OtherIncome: PropTypes.number,
        month24Equity: PropTypes.number,
        month24OtherIncome: PropTypes.number,
        month36Equity: PropTypes.number,
        month36OtherIncome: PropTypes.number,
        above36Equity: PropTypes.number,
        above36OtherIncome: PropTypes.number,
      },
    ]).isRequired,
  }).isRequired,
  id: PropTypes.number.isRequired,
  nestedColumnsNumber: PropTypes.number.isRequired,
};

export default EquityOnCancelledContractRow;
